import React, { Component } from "react";

import { Map, List } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { injectIntl, defineMessages } from "react-intl";
import { ConfigTemplate, AdminPageTitle, AdminPageTemplate } from "components";
import { CtConfigInitial, CtConfigSync } from "containers";
import * as adminActions from "modules/admin";

class CtAdminSync extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.getSystemConfigSync();
  }

  // 대상자 연동 조회
  getSystemConfigSync = async () => {
    const { AdminActions, paramInfo } = this.props;

    try {
      await AdminActions.getSystemConfigSync();
    } catch (e) {
      console.log("get admin sync", e);
    }

    this.setState({ loaded: true });
  };

  render() {
    const { formatMessage } = this.props.intl;
    if (this.state.loaded === false) {
      return null;
    }

    const { isAuth, configClassOrder, configParamOrder } = this.props;

    let classOrder = [];
    if (configClassOrder && List.isList(configClassOrder)) {
      classOrder = configClassOrder.toJS();
    }

    let paramOrder = {};
    if (configParamOrder && Map.isMap(configParamOrder)) {
      paramOrder = configParamOrder.toJS();
    }

    return (
      <AdminPageTemplate>
        <AdminPageTitle
          small
          title={defineMessages(
            formatMessage({
              id: "ConfigSync_1",
              defaultMessage: "대상자 연동",
            })
          )}
        ></AdminPageTitle>
        <ConfigTemplate
          category="configSync"
          order={classOrder}
          lists={paramOrder}
          isAuth={isAuth}
        />
        <CtConfigSync />
      </AdminPageTemplate>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    configClassOrder: state.admin.getIn(["configSync", "classOrder"]),
    configParamOrder: state.admin.getIn(["configSync", "class"]),
    isAuth: state.user.get("isAuth"),
  };
};

const mapDispatchToProps = (dispatch) => ({
  AdminActions: bindActionCreators(adminActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CtAdminSync));



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminSync.js